<div class="row" *ngIf="(tableItem | json) != '{}'">
    <div class="col-sm-12">
        <div class="row">
            <div class="col">
                <label class="fw-bold">ID</label>
                <input type="text" class="form-control" [(ngModel)]="tableItem.actionTypeId" disabled />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Description</label>
                <input type="text" class="form-control" [(ngModel)]="tableItem.actionTypeDescription" required />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Retired</label>
                <input type="checkbox" id="retiredInd" name="retiredInd" style="margin:10px;transform: scale(1.5);" [(ngModel)]="tableItem.retiredInd" />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Count Toward Daily Activity</label>
                <input type="checkbox" id="countTowardDailyActivity" name="countTowardDailyActivity" style="margin:10px;transform: scale(1.5);" [(ngModel)]="tableItem.countTowardDailyActivity" />
            </div>
        </div>
        <div class="row">
            <div class="col m-2 text-end">
                <button class="btn btn-primary m-2" (click)="save()">Save</button>
                <button class="btn btn-secondary m-2" (click)="cancel()">Cancel</button>
            </div>
        </div>
    </div>
</div>
